/*---------------------------------------------------------------------------------------------
 *  Copyright (c) Microsoft Corporation. All rights reserved.
 *  Licensed under the MIT License. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------*/

import * as React from 'react';

import { IHosportsConstantContactFormData } from './hosports-constant-contact-form.data';
import { IHosportsConstantContactFormProps } from './hosports-constant-contact-form.props.autogenerated';

export interface IHosportsConstantContactFormViewProps extends IHosportsConstantContactFormProps<IHosportsConstantContactFormData> {

}

/**
 *
 * HosportsConstantContactForm component
 * @extends {React.PureComponent<IHosportsConstantContactFormProps<IHosportsConstantContactFormData>>}
 */
class HosportsConstantContactForm extends React.PureComponent<IHosportsConstantContactFormProps<IHosportsConstantContactFormData>> {
    public render(): JSX.Element | null {

        return this.props.renderView(this.props);
    }
}

export default HosportsConstantContactForm;
